export const PricebookCompanyTemplateBasicColumn = [
    'Reference SKU',
    'Product name',
    'Purchase price',
    'Currency',
    'Favorite',
    'Type of pricebook',
    'Name of pricebook',
    'ID of pricebook',
]

export const PricebookReferenceTemplateBasicColumn = [
    'Reference SKU',
    'Pricebook‑specific SKU',
    'Product name',
    'Purchase price',
    'Currency',
    'Type of pricebook',
    'Name of pricebook',
    'ID of pricebook',
]

export const PricebookGeographyTemplateBasicColumn = [
    'Reference SKU',
    'Pricebook‑specific SKU',
    'Product name',
    'Purchase price',
    'Currency',
    'Type of pricebook',
    'Name of pricebook',
    'ID of pricebook',
]

export const PricebookRentalColumns = [
    'Unit of measurement',
    'Rental price'
]

export const PricebookAffiliateColumns = [
    'Commission %',
    'Commission amount',
]

/**
 * Base columns per pricebook type.
 * To add a new type, just add an entry here.
 * @type {Record<string, string[]>}
 */
export const PricebookTypeBaseColumns = {
    COMPANY: PricebookCompanyTemplateBasicColumn,
    REFERENCE: PricebookReferenceTemplateBasicColumn,
    GEOGRAPHY: PricebookGeographyTemplateBasicColumn,
};

/**
 * Extra columns appended after the base columns for a given category.
 * To add a new category, just add an entry here — no logic changes needed.
 * @type {Record<string, string[]>}
 */
export const PricebookCategoryExtraColumns = {
    AFFILIATE: PricebookAffiliateColumns,
};
